import { render, staticRenderFns } from "./CounselingEventsOverview.vue?vue&type=template&id=749e8b9c&"
import script from "./CounselingEventsOverview.vue?vue&type=script&lang=js&"
export * from "./CounselingEventsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports